<div class="progress-loader" [hidden]="!loading">
  <div class="loading-spinner">
      <img src="../../../assets/Infinity-1s-200px.svg">
      <span class="loading-message">Aguarde...</span>
  </div>
</div>